@if (modalOneInput?.visible) {
   <div class="modal blured-overlay fade d-block show" tabindex="-1" role="dialog" [attr.aria-labelledby]="modalOneInput?.ariaLabelledBy" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable eod-ds-modal-one">
      <div class="modal-content">
        <div class="modal-header">
          <ng-content select="[modal-header]"></ng-content>
          @if (!hasProjectedHeader) {
            <h5 class="modal-title" [id]="modalOneInput?.ariaLabelledBy"> {{ modalOneInput?.modalTitle }}</h5>
            <p [innerHTML]="modalOneInput?.modalTitleDescription" class="modal-title-description"></p>
            @if (modalOneInput?.founderImage) {
              <img class="founder-image" [src]="modalOneInput?.founderImage" alt="" />
            }
          }
        </div>
        <div class="modal-body">
          <ng-content select="[modal-body]"></ng-content>
        </div>
        <div class="modal-footer">
          <ng-content select="[modal-footer]"></ng-content>
        </div>
      </div>
    </div>
  </div>
}




